export default "__VITE_PUBLIC_ASSET__d23dff5c__"